import STATUS_CODES from 'constants/statusCodes';
import { getSetUserCallback, notifyError } from 'helpers/errorNotifier';
import { getUser } from 'helpers/user/getUser';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import InternalServerError from './500';

const Error = () => <InternalServerError />;

export async function getServerSideProps(ctx) {
	const { res, err, locale = 'en' } = ctx;
	const user = await getUser(ctx, false);

	if (err && err.statusCode && err.statusCode != STATUS_CODES.NOT_FOUND) {
		notifyError(err, {}, user?.id ? getSetUserCallback(user) : undefined);
	}

	let statusCode = STATUS_CODES.INTERNAL_SERVER_ERROR;
	statusCode = err ? err.statusCode : statusCode;
	statusCode = res ? res.statusCode : statusCode;

	return {
		props: {
			statusCode,
			...(await serverSideTranslations(locale, ['static'])),
			user: { ...user },
		},
	};
}

export default Error;
